export const getDate = (date?: Date | string | null) => {
  if (!date) {
    return null;
  }

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.valueOf())) {
    return null;
  }
  return new Date(
    parsedDate.getUTCFullYear(),
    parsedDate.getUTCMonth(),
    parsedDate.getUTCDate(),
  );
};

export const getCoverageStartDate = (
  exportInsuranceWithNullCoverageStartDateEnabled: boolean,
  coverageStartDate?: Date | string | null,
) => {
  const now = new Date();
  const utcNow = new Date(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
  );

  if (!coverageStartDate) {
    return exportInsuranceWithNullCoverageStartDateEnabled ? null : utcNow;
  }

  const coverage = new Date(coverageStartDate);
  if (isNaN(coverage.valueOf())) {
    return exportInsuranceWithNullCoverageStartDateEnabled ? null : utcNow;
  }
  return new Date(
    coverage.getUTCFullYear(),
    coverage.getUTCMonth(),
    coverage.getUTCDate(),
  );
};
